<template>
    <el-card class="page_card" ref="card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>历史计划单</span>
        </div>
        <el-form inline :model="selectForm" ref="selectForm">
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom"
                    :loading="is_select">
                    <el-option
                        v-for="item in supplier_list"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品">
                <el-select v-model="selectForm.goodsId" placeholder="请选择">
                    <el-option :label="item.name" :class="{primary_text:item.isMain && item.isMain == 1}" :value="item.id" v-for="item of goods_list" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="计划编号">
                <el-input v-model="selectForm.orderSn" placeholder="请输入计划编号"></el-input>
            </el-form-item>
            <el-form-item label="驾驶员">
                <el-input v-model="selectForm.driverName" placeholder="请输入驾驶员"></el-input>
            </el-form-item>
            <el-form-item label="驾驶员电话">
                <el-input v-model="selectForm.driverMobile" placeholder="请输入驾驶员电话"></el-input>
            </el-form-item>
            <el-form-item label="主车号">
                <el-input v-model="selectForm.plateNumber" placeholder="请输入主车号"></el-input>
            </el-form-item>
            <el-form-item label="挂车号">
                <el-input v-model="selectForm.carriageNumber" placeholder="请输入挂车号"></el-input>
            </el-form-item>
            <el-form-item label="计划日期">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="daterange"
                    align="right"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="selectForm.status" placeholder="请选择">
                    <el-option label="全部" value="all"></el-option>
                    <el-option label="已完成" value="0"></el-option>
                    <el-option label="已过期" value="3"></el-option>
                    <el-option label="客户取消" value="1"></el-option>
                    <el-option label="液厂取消" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
                <el-button plain @click="resetSelect()">重 置</el-button>
            </el-form-item>
            <!-- <el-form-item label="">
                <el-button plain type="warning" @click="colSet"> <svg-icon icon-class="options" /> 列设置</el-button>
                <el-button plain type="success" :loading="is_post" v-can="['btn:export_plan']" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
                <el-button plain type="warning" :disabled="selecte_arr.length == 0" @click="billing_all" v-if="has_permission('btn:bill_order')">批量开票 ({{selecte_arr.length}})</el-button>
            </el-form-item> -->
        </el-form>
        <el-table ref="table" border :data="data" :max-height="tableMaxHeight" :header-cell-style='{background:"#F5F7FA"}' class="history_table" @selection-change="handleSelectionChange" v-loading="is_loading" :row-class-name="tableRowClassName" tooltip-effect="dark">
            <el-table-column
                type="selection"
                width="40">
            </el-table-column>
            <el-table-column label="计划编号" width="180" v-if="colOptions.orderSn">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="goToDetail(scope.row)" type="primary">{{scope.row.orderSn}}</el-link>
                </template>
            </el-table-column>
            <!-- <el-table-column label="企业名称" width="200" v-if="colOptions.comName">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.comName}}</span>
                </template>
            </el-table-column> -->
            <el-table-column label="供应商" width="240" v-if="colOptions.supplierName">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.supplierName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="产品" width="90" v-if="colOptions.product">
                <template slot-scope="scope">
                    <span class="success_text">{{scope.row.goodsName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="计划日期" width="100" v-if="colOptions.date">
                <template slot-scope="scope">
                    {{scope.row.planDate}}
                </template>
            </el-table-column>
            <el-table-column label="主车号" width="90" v-if="colOptions.plateNumber">
                <template slot-scope="scope">
                    <span>{{scope.row.plateNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="挂车号" width="90" v-if="colOptions.carriageNumber">
                <template slot-scope="scope">
                    <span>{{scope.row.carriageNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="皮重(吨)" width="100" v-if="colOptions.tareWeight">
                <template slot-scope="scope">
                    <span v-if="scope.row.firstWeight">
                        {{scope.row.firstWeight}}
                    </span>
                    <span v-else>/</span>
                </template>
            </el-table-column>
            <el-table-column label="毛重(吨)" width="100" v-if="colOptions.grossWeight">
                <template slot-scope="scope">
                    <span v-if="scope.row.secondWeight">
                        {{scope.row.secondWeight}}
                    </span>
                    <span v-else>/</span>
                </template>
            </el-table-column>
            <el-table-column label="净重(吨)" width="100" v-if="colOptions.netWeight">
                <template slot-scope="scope">
                    <span v-if="scope.row.netWeight">
                        {{scope.row.netWeight}}
                    </span>
                    <span v-else>/</span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="挂牌价" width="120" v-if="colOptions.oldPrice">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.letterPrice}} 元/吨</span>
                </template>
            </el-table-column> -->
            <el-table-column label="采购单价" width="120" v-if="colOptions.realPrice">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.tradingPrice)}} 元/吨</span>
                </template>
            </el-table-column>
            <el-table-column label="采购吨数" width="100" v-if="colOptions.planWeight">
                <template slot-scope="scope">
                    <span class="success_text">{{scope.row.planWeight}} 吨</span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="其他费用" v-if="colOptions.otherFee">
                <template slot-scope="scope">
                    <span class="warning_text" v-if="!parseOtherFee(scope.row.otherFee).length">
                        无
                    </span>
                    <el-popover
                        v-else
                        placement="top-start"
                        width="240"
                        trigger="hover"
                    >
                        <el-table :data="parseOtherFee(scope.row.otherFee)" border>
                            <el-table-column property="name" label="费用名录"></el-table-column>
                            <el-table-column property="num" label="金额(元)"></el-table-column>
                        </el-table>
                        <el-button slot="reference" type="primary" size="mini" plain><svg-icon icon-class="money" /></el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="计划总金额" width="120" v-if="colOptions.allMoney">
                <template slot-scope="scope">
                    <span v-if="scope.row.realAmount" class="primary_text">
                        ￥ {{scope.row.realAmount}} 元
                    </span>
                    <span v-else>/</span>
                </template>
            </el-table-column>
            <el-table-column label="实际总金额" width="120" v-if="colOptions.realAmount">
                <template slot-scope="scope">
                    <span v-if="scope.row.realAmount" class="primary_text">
                        ￥ {{scope.row.realAmount}} 元
                    </span>
                    <span v-else>/</span>
                </template>
            </el-table-column>
            <el-table-column label="是否开票" width="120" v-if="colOptions.billed">
                <template slot-scope="scope">
                    <span class="warning_text" v-if="!scope.row.billed">未开票</span>
                    <span class="success_text" v-if="scope.row.billed">已开票</span>
                </template>
            </el-table-column> -->
            <!-- <el-table-column label="计划类型" v-if="colOptions.orderType">
                <template slot-scope="scope">
                    <span class="primary_text" v-if="scope.row.purchaseType == 0">本厂计划</span>
                    <span class="warning_text" v-if="scope.row.purchaseType == 1">采购计划</span>
                    <span class="primary_text" v-if="scope.row.purchaseType == 2">临时计划</span>
                    <span class="warning_text" v-if="scope.row.purchaseType == 10">其他计划</span>
                </template>
            </el-table-column>
            <el-table-column label="提货方式" width="60" v-if="colOptions.unitType">
                <template slot-scope="scope">
                    <span class="success_text" v-if="scope.row.deliverType == 0">自提</span>
                    <span class="warning_text" v-if="scope.row.deliverType == 1">配送</span>
                </template>
            </el-table-column>
            <el-table-column label="供应商" width="200" v-if="colOptions.supplierName">
                <template slot-scope="scope">
                    <span v-if="!scope.row.supplierName">/</span>
                    <span v-else class="primary_text">{{scope.row.supplierName}}</span>
                </template>
            </el-table-column> -->

            <el-table-column label="计划单状态" width="100" v-if="colOptions.status">
                <template slot-scope="scope">
                    <el-tag :type="statusType(scope.row.status)">{{parseStatus(scope.row.status)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="备注" width="65" v-if="colOptions.remark">
                <template slot-scope="scope">
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="scope.row.remark">
                        <el-button slot="reference" plain size="mini" type="primary"><svg-icon icon-class="remark" /></el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <!-- <el-table-column label="铅封号" width="80" v-if="colOptions.banNumber">
                <template slot-scope="scope">
                    <span class="warning_text" v-if="scope.row.leadSealNo">
                        {{scope.row.leadSealNo}}
                    </span>
                    <span v-else>/</span>
                </template>
            </el-table-column> -->
            <el-table-column label="附件" width="81" v-if="colOptions.enclosure">
                <template slot-scope="scope">
                    <el-button plain type="primary" size="mini" :disabled="scope.row.files.length == 0" @click="showFiles(scope.row)"><svg-icon icon-class="pdf" />({{scope.row.files.length}})</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column label="金额信息" v-if="colOptions.oldPrice || colOptions.newPrice || colOptions.cutPrice || colOptions.realPrice || colOptions.planWeight || colOptions.realWeight || colOptions.otherFee || colOptions.allMoney || colOptions.realAmount">
                
                <el-table-column label="实际价格" width="120" v-if="colOptions.newPrice">
                    <template slot-scope="scope">
                        <span class="warning_text">{{scope.row.realPrice}} 元/吨</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="优惠" width="85" v-if="colOptions.cutPrice">
                    <template slot-scope="scope">
                        <el-popover
                            placement="top-start"
                            width="100"
                            trigger="hover"
                        >
                            <el-row>
                                <el-col :span="12">
                                    临时优惠:
                                </el-col>
                                <el-col :span="12">
                                    <span class="warning_text">￥ {{scope.row.temCut}}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    销售优惠:
                                </el-col>
                                <el-col :span="12">
                                   <span class="warning_text">￥ {{scope.row.saleCut}}</span>
                                </el-col>
                            </el-row>
                            <el-button slot="reference" size="mini" plain type="danger">￥ {{scope.row.saleCut + scope.row.temCut}}</el-button>
                        </el-popover>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="实际成交价" width="120" v-if="colOptions.realPrice">
                    <template slot-scope="scope">
                        <span class="primary_text">{{scope.row.tradingPrice}} 元/吨</span>
                    </template>
                </el-table-column>
                <el-table-column label="计划装液量" width="75" v-if="colOptions.planWeight">
                    <template slot-scope="scope">
                        <span class="success_text">{{scope.row.planWeight}} 吨</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际装液量" width="65" v-if="colOptions.realWeight">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.netWeight">/</span>
                        <span v-else class="warning_text">{{scope.row.netWeight}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="其他费用" v-if="colOptions.otherFee">
                    <template slot-scope="scope">
                        <span class="warning_text" v-if="!parseOtherFee(scope.row.otherFee).length">
                            无
                        </span>
                        <el-popover
                            v-else
                            placement="top-start"
                            width="240"
                            trigger="hover"
                        >
                            <el-table :data="parseOtherFee(scope.row.otherFee)" border>
                                <el-table-column property="name" label="费用名录"></el-table-column>
                                <el-table-column property="num" label="金额(元)"></el-table-column>
                            </el-table>
                            <el-button slot="reference" type="primary" size="mini" plain><svg-icon icon-class="money" /></el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="计划总金额" width="120" v-if="colOptions.allMoney">
                    <template slot-scope="scope">
                        <span v-if="scope.row.realAmount" class="primary_text">
                            ￥ {{scope.row.realAmount}} 元
                        </span>
                        <span v-else>/</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际总金额" width="120" v-if="colOptions.realAmount">
                    <template slot-scope="scope">
                        <span v-if="scope.row.realAmount" class="primary_text">
                            ￥ {{scope.row.realAmount}} 元
                        </span>
                        <span v-else>/</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否开票" width="120" v-if="colOptions.billed">
                    <template slot-scope="scope">
                        <span class="warning_text" v-if="!scope.row.billed">未开票</span>
                        <span class="success_text" v-if="scope.row.billed">已开票</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
            <!-- <el-table-column label="时间节点" v-if="colOptions.createTime || colOptions.processOneTime || colOptions.processTwoTime || colOptions.leaveTime"> -->
                <el-table-column label="创建时间" width="160" v-if="colOptions.createTime">
                    <template slot-scope="scope">
                        {{scope.row.addTime}}
                    </template>
                </el-table-column>
                <el-table-column label="一次过磅时间" width="160" v-if="colOptions.processOneTime">
                    <template slot-scope="scope">
                        <div v-if="scope.row.startTime">
                            {{scope.row.startTime}}
                        </div>
                        <div v-else>
                            /
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="二次过磅时间" width="160" v-if="colOptions.processTwoTime">
                    <template slot-scope="scope">
                        <div v-if="scope.row.endTime">
                            {{scope.row.endTime}}
                        </div>
                        <div v-else>
                            /
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="车辆离场时间" width="160" v-if="colOptions.leaveTime">
                    <template slot-scope="scope">
                        <div v-if="scope.row.leaveTime">
                            {{scope.row.leaveTime}}
                        </div>
                        <div v-else>
                            /
                        </div>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="操作888" width="140" fixed="right" v-if="has_permission('btn:bill_order')">
                    <template slot-scope="scope">
                        <span class="primary_text" @click="copyPlan(scope.row)" style="margin-left:15px;cursor: pointer;">复制计划</span>
                    </template>
                </el-table-column> -->
            <!-- </el-table-column>
            <el-table-column label="车辆信息" v-if="colOptions.plateNumber || colOptions.carriageNumber || colOptions.driverName || colOptions.driverMobile || colOptions.driverCard || colOptions.escortName || colOptions.escortMobile || colOptions.expressName"> -->
                
                <el-table-column label="驾驶员" width="100" v-if="colOptions.driverName">
                    <template slot-scope="scope">
                        <span>{{scope.row.driverName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="驾驶员电话" width="110" v-if="colOptions.driverMobile">
                    <template slot-scope="scope">
                        <span>{{scope.row.driverMobile}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="司机身份证号" width="200" v-if="colOptions.driverCard">
                    <template slot-scope="scope">
                        <span v-if="scope.row.driverIdNumber">{{scope.row.driverIdNumber}}</span>
                        <span v-else>/</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="押运员" width="100" v-if="colOptions.escortName">
                    <template slot-scope="scope">
                        <span>{{scope.row.escortName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="押运员电话" width="110" v-if="colOptions.escortMobile">
                    <template slot-scope="scope">
                        <span>{{scope.row.escortMobile}}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="物流公司名称" width="200" v-if="colOptions.expressName">
                    <template slot-scope="scope">
                        <span>{{scope.row.expressName}}</span>
                    </template>
                </el-table-column>
            <!-- </el-table-column> -->
            <!-- <el-table-column label="过磅信息" v-if="colOptions.tareWeight || colOptions.grossWeight || colOptions.netWeight || colOptions.banNumber || colOptions.enclosure">
                
                <el-table-column label="铅封号" width="80" v-if="colOptions.banNumber">
                    <template slot-scope="scope">
                        <span class="warning_text" v-if="scope.row.leadSealNo">
                            {{scope.row.leadSealNo}}
                        </span>
                        <span v-else>/</span>
                    </template>
                </el-table-column>
                <el-table-column label="附件" width="81" v-if="colOptions.enclosure">
                    <template slot-scope="scope">
                        <el-button plain type="primary" size="mini" :disabled="scope.row.files.length == 0" @click="showFiles(scope.row)"><svg-icon icon-class="pdf" />({{scope.row.files.length}})</el-button>
                    </template>
                </el-table-column>
            </el-table-column> -->

            
            <el-table-column label="操作" width="140" fixed="right" v-if="has_permission('btn:bill_order')">
                <template slot-scope="scope">
                     <span class="primary_text" @click="copyPlan(scope.row)" style="margin-left:15px;cursor: pointer;">复制计划</span>
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="total, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>

        <el-dialog title="列设置" :visible.sync="colConfigDialog" width="20%">
            <el-tree
                :data="colConfig"
                show-checkbox
                ref="tree"
                node-key="key"
                :props="defaultProps">
            </el-tree>
            <span slot="footer" class="dialog-footer">
                <el-button @click="colConfigDialog = false" plain>取 消</el-button>
                <el-button type="success" @click="saveOptions" plain>保 存</el-button>
            </span>
        </el-dialog>

        <el-drawer
            title="附件"
            :visible.sync="show_files_dialog"
            size="25%"
            direction="rtl"
            >
            <el-row v-if="active_item" style="padding: 20px">
                <el-col style="width: 100%;" :span="24" v-for="item of active_item.files" :key="item.id">
                    <div v-if="item.fileType != 'pdf'">
                        <el-image style="width: 100%;border-radius: 10px" :src="item.url"></el-image>
                        <el-divider></el-divider>
                    </div>
                    <div v-else>
                        <el-button plain size="large" type="primary" @click="preview(item)"> <svg-icon icon-class="pdf" /> 文件预览</el-button>
                        <el-divider></el-divider>
                    </div>
                </el-col>
            </el-row>
        </el-drawer>

        <el-dialog title="文件预览" :visible.sync="preview_dialog" width="60%">
            <el-row>
                <el-col :span="24" style="overflow-x: hidden;overflow-y: auto;height: 65vh" v-if="preview_file && preview_file.fileType != 'pdf'">
                    <el-image fit="cover" style="width: 100%" v-else :src="preview_file.url" v-if="preview_file"></el-image>
                </el-col>
                <el-col :span="24" style="overflow-x: hidden;overflow-y: auto;height: 65vh" v-loading="is_show_pdf" v-if="preview_file && preview_file.fileType == 'pdf'">
                    <pdf ref="pdf"
                         style="width: 100%"
                         v-for="i in numPages"
                         :key="i"
                         :src="preview_file.url"
                         :page="i"></pdf>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 新增计划 -->
        <el-dialog :title="id==0?'添加采购计划':'修改采购计划'" :visible.sync="isAdd" width="30%" @close="close">
            <el-form label-position="right" :model="addForm" ref="addForm" :rules="Rules" label-width="120px" >
                <el-form-item label="供应商" prop="supplierId">
                     <el-select style="width: 100%" v-model="addForm.supplierId"  :disabled=disabledData placeholder="请选择">
                        <el-option
                            v-for="item in supplier_list"
                            :key="item.id"
                            :label="item.displayName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="计划日期" prop="date">
                    <el-select v-model="addForm.date" placeholder="请选择采购日期" style="width:100%">
                        <el-option
                            v-for="(item,index) in dates"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物资" prop="goodsId">
                    <el-select v-model="addForm.goodsId" placeholder="请选择"  :disabled=disabledData style="width:100%">
                        <el-option
                            v-for="item in procuroct"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主车号" prop="plateNumber">
                    <el-input placeholder="请输入采购主车号: 宁A12346" show-word-limit  :disabled=disabledData maxlength="7" v-model="addForm.plateNumber" ></el-input>
                </el-form-item>
                <el-form-item label="挂车号" prop="carriageNumber">
                    <el-input placeholder="请输入采购挂车号: 宁A1234挂" show-word-limit  :disabled=disabledData maxlength="7" v-model="addForm.carriageNumber" ></el-input>
                </el-form-item>
                <el-form-item label="驾驶员" prop="driverName">
                    <el-input placeholder="请输入驾驶员" maxlength="10" show-word-limit  :disabled=disabledData v-model="addForm.driverName" ></el-input>
                </el-form-item>
                <el-form-item label="驾驶员电话" prop="driverMobile">
                    <el-input placeholder="请输入驾驶员电话" maxlength="11" show-word-limit :disabled=disabledData v-model="addForm.driverMobile" ></el-input>
                </el-form-item>
                <el-form-item label="采购单价" prop="unitPrice">
                    <el-input placeholder="请输入采购单价"   :disabled=disabledData v-model="addForm.unitPrice"></el-input>
                </el-form-item>
                <el-form-item label="采购吨数" prop="weight">
                    <el-input placeholder="请输入采购吨数"  :disabled=disabledData v-model="addForm.weight"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                     <el-input v-model="addForm.remark"  :disabled=disabledData type="textarea" maxlength="100" :autosize="{ minRows: 4, maxRows: 8}" placeholder="备注" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" :loading="is_post" @click="addSubmit()">提 交</el-button>
                    <el-button plain :loading="is_post" @click="resetAdd()">重 置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </el-card>
</template>

<script>
import request from '@/utils/request'
import pdf from "vue-pdf"
import can from "@/directive/can/index.js"
import {mapGetters} from 'vuex'
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'
import {stringTrim} from '@/utils/elvalid'
import {parseTime,deepClone} from '@/utils'

export default {
    components:{
        pdf
    },
    computed:{
        ...mapGetters([
            'permissions'
        ])
    },
    directives:{can},
    name: 'order_history',
    data(){
        return {
            baseUrl:"",
            is_ok:false,
            is_loading:false,
            is_post:false,
            data:[],
            procuroct:[],//产品列表
            supplier_list:[],//供货公司
            dates:[],//计划日期
            id:0,
            isAdd:false,
            disabledData:false,
            addForm:{
               supplierId:'',
               driverMobile:'',
               driverName:'',
               unitPrice:0,
               carriageNumber:'',
               date:'',
               goodsId:'',
               plateNumber:'',
               weight:0,
               remark:''
            },
            Rules:{
                supplierId:[
                    {required:true,message:'请选择供应商',trigger:'blur'}
                ],
                goodsId:[
                    {required:true,message:'请选择采购产品名称',trigger:'blur'}
                ],
                 carriageNumber:[
                    {required: true, message: '请输入挂车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dA-Z]{4}挂$/,message:"请输入正确的挂车号",trigger: 'blur'}
                ],
                date:[
                    {required: true, message: '请选择日期', trigger: 'blur'},
                ],
                driverMobile:[
                    {required: true, message: '请输入驾驶员电话', trigger: 'blur'},
                    {pattern:/^1[345789]\d{9}$/,message:"请输入正确的驾驶员电话",trigger: 'blur'}
                ],
                driverName:[
                    {required: true, message: '请输入驾驶员', trigger: 'blur'},
                    { validator: stringTrim, trigger: 'blur' }
                ],
                plateNumber:[
                    {required: true, message: '请输入主车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                ],
                // unitPrice:[
                //     {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                // ],
                // weight:[
                //     {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                // ],
            },
            selectForm:{
                goodsId:"all",
                timeRange:[],
                orderSn:"",
                comId:"",
                driverName:"",
                driverMobile:"",
                carriageNumber:"",
                plateNumber:"",
                status:"all",
                pageNum:1,
                pageSize:10,
                type:1
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            total:0,
            is_select:false,
            componys:[],
            colConfigDialog:false,
            colOptions:{
                orderSn:false,
                comName:false,
                product:false,
                orderType:false,
                unitType:false,
                supplierName:false,
                date:false,
                status:false,
                remark:false,
                oldPrice:false,
                newPrice:false,
                cutPrice:false,
                realPrice:false,
                planWeight:false,
                realWeight:false,
                otherFee:false,
                allMoney:false,
                plateNumber:false,
                carriageNumber:false,
                driverName:false,
                driverMobile:false,
                escortName:false,
                escortMobile:false,
                expressName:false,
                tareWeight:false,
                grossWeight:false,
                netWeight:false,
                banNumber:false,
                enclosure:false,
                createTime:false,
                processOneTime:false,
                processTwoTime:false,
                leaveTime:false,
                realAmount:false,
                driverCard:false,
                car:false,
                money:false,
                times:false,
                weights:false,
                billed:false
            },
            colConfig:[
                {
                    key:"orderSn",
                    label:"编号"
                },
                {
                    key:"comName",
                    label:"企业名称"
                },
                {
                    key:"product",
                    label:"产品名称"
                },
                {
                    key:"orderType",
                    label:"计划类型"
                },
                {
                    key:"unitType",
                    label:"提货方式"
                },
                {
                    key:"supplierName",
                    label:"供应商"
                },
                {
                    key:"date",
                    label:"计划日期"
                },
                {
                    key:"status",
                    label:"计划单状态"
                },
                {
                    key:"remark",
                    label:"备注"
                },
                {
                    key:"money",
                    label:"金额信息",
                    children:[
                        {
                            key:"oldPrice",
                            label:"挂牌价"
                        },
                        {
                            key:"newPrice",
                            label:"执行价"
                        },
                        {
                            key:"cutPrice",
                            label:"优惠"
                        },
                        {
                            key:"realPrice",
                            label:"成交价"
                        },
                        {
                            key:"planWeight",
                            label:"计划装液量"
                        },
                        {
                            key:"realWeight",
                            label:"实际装液量"
                        },
                        {
                            key:"otherFee",
                            label:"其他费用"
                        },
                        {
                            key:"allMoney",
                            label:"计划总金额"
                        },
                        {
                            key:"realAmount",
                            label:"实际总金额"
                        },
                        {
                            key:"billed",
                            label:"是否开票"
                        }
                    ]
                },
                {
                    key:"car",
                    label:"车辆信息",
                    children: [
                        {
                            key:"plateNumber",
                            label:"主车号"
                        },
                        {
                            key:"carriageNumber",
                            label:"挂车号"
                        },
                        {
                            key:"driverName",
                            label:"驾驶员"
                        },
                        {
                            key:"driverMobile",
                            label:"驾驶员电话"
                        },
                        // {
                        //     key:"driverCard",
                        //     label:"司机身份证号"
                        // },
                        {
                            key:"escortName",
                            label:"押运员"
                        },
                        {
                            key:"escortMobile",
                            label:"押运员电话"
                        },
                        {
                            key:"expressName",
                            label:"物流公司名称"
                        }
                    ]
                },
                {
                    key:"weights",
                    label:"过磅信息",
                    children:[
                        {
                            key:"tareWeight",
                            label:"皮重"
                        },
                        {
                            key:"grossWeight",
                            label:"毛重"
                        },
                        {
                            key:"netWeight",
                            label:"净重"
                        },
                        {
                            key:"banNumber",
                            label:"铅封号"
                        },
                        {
                            key:"enclosure",
                            label:"附件"
                        },
                    ]
                },
                {
                    key:"times",
                    label:"时间节点",
                    children:[
                        {
                            key:"createTime",
                            label:"创建时间",
                        },
                        {
                            key:"processOneTime",
                            label:"一次过磅时间"
                        },
                        {
                            key:"processTwoTime",
                            label:"二次过磅时间"
                        },
                        {
                            key:"leaveTime",
                            label:"车辆离场时间"
                        }
                    ]
                }
            ],
            defaultProps:{
                children: 'children',
                label: 'label'
            },
            tableMaxHeight:0,
            showtable:false,
            tree_set:null,
            tree_arr:[],
            goods_list:[
                {id:"all",name:"全部"}
            ],
            selecte_arr:[],
            active_item:null,
            show_files_dialog:false,
            preview_dialog:false,
            numPages:null,
            preview_file:null,
            is_show_pdf:false,
        }
    },
    methods:{
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        resetSelect(){
            this.selectForm = {
                goodsId:"all",
                timeRange:[],
                orderSn:"",
                comId:"",
                driverName:"",
                driverMobile:"",
                carriageNumber:"",
                plateNumber:"",
                status:"all",
                pageNum:1,
                pageSize:10
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        selectSubmit(){
            this.getData();
        },
        getData(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("order/purchase/history_list",this.selectForm).then(res=>{

                this.data = res.data.list;
                this.total = res.data.total;
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.is_ok = true;
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-135;
                    // this.showtable = true;
                }
            }).catch(err=>{
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.is_ok = true;
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-135;
                    // this.showtable = true;
                }
            });
        },
        handleSelectionChange(arr){
            this.selecte_arr = arr;
        },
        //分页改变
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        selectComMethod(name){
            if(name.length > 1){
                this.is_select = true;
                request.get("company/option?keyword="+name).then(res=>{
                    if(res.data && res.data.length > 0){
                        this.componys = res.data;
                    }else{
                        this.componys = [];
                    }
                    this.is_select = false;
                }).catch(err=>{
                    this.is_select = false;
                });
            }
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        parseOtherFee(otherFee){
            return JSON.parse(otherFee);
        },
      //   colSet(){
      //       this.colConfigDialog = true;
      //       this.tree_arr = [];
      //       for(let k of Object.keys(this.colOptions)){
      //           if(this.colOptions[k]){
      //               this.tree_arr.push(k);
      //           }
      //       }
      //       setTimeout(()=>{
      //           this.$refs.tree.setCheckedKeys(this.tree_arr);
      //       },10);
      //   },
        goToDetail(item){
            if(!this.has_permission("view:financial_detail")){
                return false;
            }
            this.$router.push({name:"financial_detail",params:{id:item.id}});
        },
        //保存到excel文件中
      //   async exportExcel(){
      //       this.is_post = true;
      //       try{
      //           let res = await fetch(this.baseUrl+"/order/history_excel",{
      //               method:"POST",
      //               headers:{
      //                   "Authorization":getToken(),
      //                   "Content-Type":"application/json;charset=utf-8"
      //               },
      //               body:JSON.stringify(this.selectForm)
      //           });
      //           let blob = await res.blob();
      //           const a= document.createElement("a")
      //           a.href = URL.createObjectURL(blob)
      //           a.download = "计划单列表.xls"
      //           a.click()
      //           URL.revokeObjectURL(a.href)
      //           this.$message.success("导出成功!");
      //       }catch(err){
      //           console.log(err);
      //       }finally {
      //           this.is_post = false;
      //       }
      //   },
        //保存配置
        saveOptions(){
            let keys = this.$refs.tree.getCheckedKeys();
            for(let k in this.colOptions){
                if(keys.includes(k)){
                    this.colOptions[k] = true;
                }else{
                    this.colOptions[k] = false;
                }
            }
            window.localStorage.setItem("order_history_option",JSON.stringify(keys));
            this.$message.success("保存配置成功!");
            this.colConfigDialog = false;
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        getGoodsList(){
            request.get("goods/list?keyword=").then(res=>{
                this.goods_list = this.goods_list.concat(res.data);
            }).catch(err=>{
                console.log(err);
            });
        },
        parseStatus(num) {
            switch (num) {
            case 0:
                return "待审核";
            case 10:
                return "已审核"; //待打卡
            case 15:
                return "已打卡"; //待登记
            case 16:
                return "已登记"; //待入场安检
            case 21:
                return "入厂安检"; //待一次过磅
            case 23:
                return "一次过磅";//待充装
            case 24:
                return "已充装"; //待出厂安检
            case 26:
                return "出厂安检"; //待二次过磅
            case 27:
                return "二次过磅"; //待打印
            case 30:
                return "已完成"; //已打印
            case 90:
                return "客户取消";
            case 91:
                return "液厂取消";
            case 92:
                return "已过期";
            }
        },
        statusType(n){
            if(n < 10){
                return "warning";
            }else if(n >= 10 && n < 20){
                return "primary";
            }else if(n >= 20 && n <=30){
                return "success";
            }else {
                return "danger";
            }
        },
        //选择开票
      //   billing_all(){
      //       let arr = [];
      //       for(let item of this.selecte_arr){
      //           if(!item.billed && item.status > 29 && item.status < 90){
      //               arr.push(item.id);
      //           }
      //       }
      //       if(arr.length == 0){
      //           this.$message.warning("没有符合开票条件的计划单,请重新选择!");
      //           this.$refs["table"].clearSelection();
      //           return false;
      //       }

      //       this.$confirm(`${arr.length}条计划单可标记为开票状态, 是否继续?`, '提示', {
      //           confirmButtonText: '确定',
      //           cancelButtonText: '取消',
      //           type: 'warning'
      //       }).then(() => {
      //           this.is_post = true;
      //           request.post("order/mark_bill",{orderIds:arr}).then(res=>{
      //               for(let item of data){
      //                   if(arr.includes(item.id)){
      //                       item.billed = true;
      //                   }
      //               }
      //               for(let item of this.selecte_arr){
      //                   if(arr.includes(item.id)){
      //                       item.billed = true;
      //                   }
      //               }
      //               this.$message.success(`操作成功,共标记开票${arr.length}条!`);
      //               this.$refs["table"].clearSelection();
      //               this.is_post = false;
      //           }).catch(err=>{
      //               this.is_post = false;
      //           });
      //       });
      //   },
        billing(item){
            this.$confirm('此操作会将该计划单标记为已开票, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.is_post = true;
                request.post("order/mark_bill",{orderIds:[item.id]}).then(res=>{
                    item.billed = true;
                    this.$message.success("操作成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        tableRowClassName({row,rowIndex}){
            if(row.status == 30){
                return "success-row";
            }else if(row.status == 90){
                return "warning-row";
            }else {
                return "danger-row";
            }
        },
        showFiles(item){
            this.active_item = item;
            this.show_files_dialog = true;

        },
        getNumPages(url) {
            return new Promise((resolve,reject)=>{
                let loadingTask = pdf.createLoadingTask(url)
                loadingTask.promise.then(pdf => {
                    this.numPages = pdf.numPages
                    resolve();
                }).catch(err => {
                    console.error('pdf 加载失败', err);
                    this.is_show_pdf = false;
                    reject(err);
                })
            });
        },
        async preview(file){
            if(file.fileType == "pdf"){
                //pdf
                this.preview_file = file;
                this.preview_dialog = true;
                this.is_show_pdf = true;
                await this.getNumPages(file.url);
                this.is_show_pdf = false;
            }else{
                this.preview_file = file;
                this.preview_dialog = true;
            }
        },
        //复制计划
        copyPlan(item){
            this.isAdd=true;
            this.addForm.supplierId=item.supplierId;
            this.addForm.driverMobile=item.driverMobile;
            // this.addForm.date=item.planDate;
            this.addForm.driverName=item.driverName;
            this.addForm.unitPrice=item.realPrice;
            this.addForm.carriageNumber=item.carriageNumber;
            this.addForm.goodsId=item.goodsId;
            this.addForm.weight=item.planWeight;
            this.addForm.plateNumber=item.plateNumber;
            // this.addForm.remark=item.remark;
            this.addForm.remark="";
        },
        //获取产品列表
        procuremData(){
            request.get("material/dropdown").then(res=>{
                this.procuroct = res.data;
            }).catch(err=>{

            });
        },
        //供货公司
        get_supplier_list(){
            request.post("company/logistics_supplier_option",{type:1,keyword:""}).then(res=>{
                this.supplier_list = res.data;
            }).catch(err=>{
                console.log(err);
            });
        },
        //新建
        addSubmit(){
            if(this.id==0){
                 this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                    request.post('order/purchase/create',this.addForm).then(res=>{
                        if(res.code==200){
                            this.isAdd=false;
                            this.is_post=false
                            this.$refs["addForm"].resetFields();
                            this.$message.success("创建成功!");
                            this.$router.push({name:'financial_procurement'});
                        }
                    
                    }).catch(err=>{
                        this.is_post=false
                        console.log('新增采购计划失败')
                    })
                })
            }else{
                this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                   
                    request.post('order/purchase/edit',this.addForm).then(res=>{
                        if(res.code==200){
                            this.isAdd=false;
                            this.is_post=false;
                             this.id=0;
                             this.addForm={
                                supplierId:'',
                                driverMobile:'',
                                driverName:'',
                                unitPrice:'',
                                carriageNumber:'',
                                goodsId:'',
                                plateNumber:'',
                                weight:'',
                                remark:''
                            }
                            this.$refs["addForm"].resetFields();
                            this.disabledData=false;
                            this.getData();
                        }
                    
                    }).catch(err=>{
                        this.is_post=false
                        console.log('修改采购计划失败')
                    })
                })
            }
            
        },
        //重置
        resetAdd(){
            this.$refs["addForm"].resetFields();
            this.addForm={
                supplierId:'',
                driverMobile:'',
                driverName:'',
                unitPrice:'',
                carriageNumber:'',
                goodsId:'',
                plateNumber:'',
                weight:'',
                remark:''
            }
        },
        close(){
            this.id=0;
            this.addForm={
                supplierId:'',
                driverMobile:'',
                driverName:'',
                unitPrice:'',
                carriageNumber:'',
                goodsId:'',
                plateNumber:'',
                weight:'',
                remark:''
            }
            this.disabledData=false;
        },
        
       
    },
    created() {
        let options = window.localStorage.getItem("order_history_option");
        if(options){
            let keys = JSON.parse(options);
            for(let k in this.colOptions){
                if(keys.includes(k)){
                    this.colOptions[k] = true;
                }else{
                    this.colOptions[k] = false;
                }
            }
        }else{
            let arr = [];
            for(let item of this.colConfig){
                if(typeof item.children != "undefined" && item.children.length){
                    for(let it of item.children){
                        this.colOptions[it.key] = true;
                        arr.push(it.key);
                    }
                }else{
                    this.colOptions[item.key] = true;
                    arr.push(item.key);
                }
            }
            window.localStorage.setItem("order_history_option",JSON.stringify(arr));
        }
        this.getGoodsList();


        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
        //获取产品列表
        this.procuremData();
        //计划日期
        let time = new Date();
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        time = time.getTime()+86400000;
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));

    },
    mounted() {
        this.getData(true);
         //供货公司
        this.get_supplier_list();
        this.getCompany();
    }
}
</script>

<style scoped lang="scss">

</style>
